import Repository from './Repository'
import TokenService from '../helpers/token'

const resource = `${Repository.defaults.baseURL}/order`
const resourceTutor = `${Repository.defaults.baseUrlTutor}`
const resourceV2 = `${Repository.defaults.baseURL}/v2/order`
const resourceV4 = `${Repository.defaults.baseURL}/v4/order`
const pcmResource = `${Repository.defaults.pcmUrl}`

export default {

  async create(params) {
    const response = await Repository.post(`${resource}`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async createV2(params) {
    const response = await Repository.post(`${resourceV2}`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async list(params) {
    const response = await Repository.get(`${resourceV4}`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async detail(id) {
    const response = await Repository.get(`${resource}/${id}`, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async detailV2(id) {
    const response = await Repository.get(`${resourceV2}/${id}/trail`, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async update(id, params) {
    const response = await Repository.patch(`${resource}/${id}`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async updateV2(id, params) {
    const response = await Repository.patch(`${resourceV2}/${id}`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async changeStatus(id, body) {
    const response = await Repository.patch(`${resource}/${id}/status`, body, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async exportExcelContact(params = {}) {
    const response = await Repository.get(`${resource}/export/excel`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getEndDate(products) {
    const response = await Repository.post(`${resource}/product-end-date`, products, {
      headers: TokenService.getHeader()
    })
    return response
  },

  async confirmPayment(params) {
    const response = await Repository.post(`${resource}/confirm-payment`, params, {
      headers: TokenService.getHeader()
    })
    return response
  },

  async getListOrderAccount(params) {
    const response = await Repository.get(`${resource}/${params.orderId}/account`, {
      headers: TokenService.getHeader()
    });
    return response;
  },

  async ctvCreate(params) {
    const response = await Repository.post(`${resource}/ctv-create`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async exportExcelContactDoiSoat(params = {}) {
    const response = await Repository.get(`${resource}/export/excel-order-doisoat`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async exportExcelOrderAccountant(params = {}) {
    const response = await Repository.get(`${resource}/export/excel-order-accountant`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async exportExcelInvoiceAccountant(params = {}) {
    const response = await Repository.get(`${resource}/export/excel-invoice-accountant`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  // đơn hàng bên tutor
  async getTransferOrderStudents(contactId) {
    const response = await Repository.get(`${resourceTutor}/transfer/get-transfer-product?contactId=${contactId}`, {
        headers: TokenService.getHeader(),
    })
    return response;
  },
  async getTransferOrderStudentsV2(contactId) {
    const response = await Repository.get(`${resourceTutor}/v2/transfer-order/get-transfer-product?contactId=${contactId}`, {
      headers: TokenService.getHeader(),
    })
    return response;
  },
  async listV2(params) {
    const response = await Repository.get(`${Repository.defaults.baseURL}/v2/order`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getTrailOfOrder(orderId) {
    const response = await Repository.get(`${Repository.defaults.baseURL}/v2/order/${orderId}/trail`, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getListOrderPaymentCheckout(params){
    const response = await Repository.get(`${Repository.defaults.baseURL}/transaction-order`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getOrderDetailByCode(code) {
    const params = {
      code: code,
    }
    const response = await Repository.get(`${Repository.defaults.baseURL}/order/v3/list`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getForReconcile(code) {
    const params = {
      code: code,
    }
    const response = await Repository.get(`${Repository.defaults.baseURL}/order-receipt/get-for-reconcile`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  
 
  async getListCountStatusOrderPaymentCheckout(params){
    const response = await Repository.get(`${Repository.defaults.baseURL}/transaction-order/transactionStatusCounts`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getListBanks(){
    const response = await Repository.get(`${Repository.defaults.baseURL}/transaction-order/banks`, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async linkOrderWithTransaction(body){
    const response = await Repository.patch(`${Repository.defaults.baseURL}/transaction-order/checkingOrder`,body, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async linkOrderWithTransactionApproved(body){
    const response = await Repository.patch(`${Repository.defaults.baseURL}/transaction-order/recheckingOrder`,body, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async checkingReceipt(body){
    const response = await Repository.patch(`${Repository.defaults.baseURL}/transaction-order/checkingReceipt`,body, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async recheckingReceipt(body){
    const response = await Repository.patch(`${Repository.defaults.baseURL}/transaction-order/recheckingReceipt`,body, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async approvedTransaction(transactionId){
    const response = await Repository.patch(`${Repository.defaults.baseURL}/transaction-order/approvedTransaction`, {transactionId: transactionId}, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async deniedTransaction(body){
    const response = await Repository.patch(`${Repository.defaults.baseURL}/transaction-order/refuseApprovedTransaction`, body, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async changeTransactionStatus(body){
    const response = await Repository.post(`${Repository.defaults.baseURL}/transaction-order/changeStatus`, body, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async exportExcelOrderPaymentChecklist(params){
    const response = await Repository.get(`${Repository.defaults.baseURL}/transaction-order/export`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getListHistoryLogs(transactionId){
    const response = await Repository.get(`${Repository.defaults.baseURL}/transaction-order/actionHistories?transactionId=${transactionId}&limit=20&offset=0`, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getListApproveBy(){
    const response = await Repository.get(`${Repository.defaults.baseURL}/transaction-order/approvedBy`, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getListProductLearnType(params){
    const response = await Repository.get(`${Repository.defaults.baseURL}/order/product-end-date-learn-type`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getEndDateV2(products) {
    const response = await Repository.post(`${resource}/product-end-date-v2`, products, {
      headers: TokenService.getHeader()
    })
    return response
  },

  async getProductAttributes(params) {
    const response = await Repository.get(`${pcmResource}/product-attributes`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getClassType(params) {
    const response = await Repository.get(`${pcmResource}/skus/class-type-and-lessons-group`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async advanceSearchForCombo(params) {
    const response = await Repository.get(`${pcmResource}/skus`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response
  },
  async advanceSearchForComboV2(params) {
    const response = await Repository.get(`${pcmResource}/skus/search-sku-v2`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response
  },
  async getVersionOrder() {
    const response = await Repository.get(`${Repository.defaults.baseURL}/setting/order-version-config`, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async createOrderV2(params) {
  const response = await Repository.post(`${Repository.defaults.baseURL}/order-version-2`, params, {
    headers: TokenService.getHeader()
  })
  return response
},
  async getOrderDetailV2(orderId) {
    const response = await Repository.get(`${Repository.defaults.baseURL}/order-version-2/${orderId}`, {
      headers: TokenService.getHeader()
    })
    return response
  },
  async getHistory(params) {
    const response = await Repository.get(`${pcmResource}/order-receipt`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response
  },
  async extraPayment(body) {
    const response = await Repository.post(`${Repository.defaults.baseURL}/order-version-2/payment`, body, {
      headers: TokenService.getHeader(),
    });
    return response
  },
  async updateStatusHistoryOrderByID(id,body) {
    const response = await Repository.patch(`${pcmResource}/order-receipt/${id}/status`, body, {
      headers: TokenService.getHeader(),
    });
    return response
  },
  async cancelOrderV2(orderId) {
    const response = await Repository.patch(`${Repository.defaults.baseURL}/order-version-2/${orderId}/cancel-order`, {}, {
      headers: TokenService.getHeader()
    })
    return response
  },

  async getCampaigns(body) {
    return await Repository.post(`${pcmResource}/campaign/applicable-for-order-product`, body, {
      headers: TokenService.getHeader(),
    });
  },

  async getApplicableForOrder(body) {
    const response = await Repository.post(`${pcmResource}/campaign/applicable-for-order`, body, {
      headers: TokenService.getHeader(),
    });
    return response
  },

  async checkPromotionCode(body) {
    const response = await Repository.post(`${pcmResource}/campaign/check-promotion-code`, body, {
      headers: TokenService.getHeader(),
    });
    return response
  },

  async getCampaignPilot(params) {
    const response = await Repository.get(`${pcmResource}/campaign/pilot`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response
  },
  async getEndDateCP(params) {
    const response = await Repository.post(`${Repository.defaults.baseURL}/order-version-2/get-end-date/create-payment`, params, {
      headers: TokenService.getHeader(),
    });
    return response
  },
  async getEndDateCO(params) { 
    const response = await Repository.post(`${Repository.defaults.baseURL}/order-version-2/get-end-date/create-order`, params , {
      headers: TokenService.getHeader(),
    });
    return response
  },
  async getCampaignsByCode(body) {
    const response = await Repository.post(`${pcmResource}/campaign/check-promotion-code-for-order-product`, body, {
      headers: TokenService.getHeader(),
    });
    return response
  },
  async getHistoryOrderDetail(orderId) {
    const response = await Repository.get(`${Repository.defaults.baseURL}/order-receipt/${orderId}`, {
      headers: TokenService.getHeader()
    })
    return response
  },
  async getAutoFillOrderDetail(params) {
    const response = await Repository.get(`${Repository.defaults.baseURL}/order-version-2/get-auto-fill-data`, {
      params,
      headers: TokenService.getHeader()
    })
    return response
  },
  async receiptList(params) {
    const response = await Repository.get(`${Repository.defaults.baseURL}/order-receipt/list`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response
  },
  async getProductPaymentUnitApi(data) {
    const response = await Repository.post(`${Repository.defaults.baseURL}/order-version-2/get-product-payment-unit`, data,{
      headers: TokenService.getHeader(),
    });
    return response
  },
  async getCheckOrderProductTransferenceApi(orderId) {
    const response = await Repository.get(`${Repository.defaults.baseURL}/order-version-2/check-order-product-transference/${orderId}`, {
      headers: TokenService.getHeader(),
    });
    return response
  },
  async createUpsaleDraftApi(data) {
    const response = await Repository.post(`${Repository.defaults.baseURL}/order-version-2/create-upsale-draft`,data, {
      headers: TokenService.getHeader(),
    });
    return response
  },
  async createUpsaleOrderApi(data) {
    const response = await Repository.post(`${Repository.defaults.baseURL}/order-version-2/create-upsale-order`,data, {
      headers: TokenService.getHeader(),
    });
    return response
  },
  async getOrderReceiptApi(params) {
    const response = await Repository.get(`${pcmResource}/order-receipt/order-receipts-and-payment-slips`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response
  },
  async getPaymentSlipApi(orderId) {
    const response = await Repository.get(`${Repository.defaults.baseURL}/order-receipt/get-payment-slip/${orderId}`, {
      headers: TokenService.getHeader(),
    });
    return response
  },
  async cancelUpSaleOrderApi(recordId, data) {
    const response = await Repository.patch(`${Repository.defaults.baseURL}/order-version-2/change-upsale-draft-status/${recordId}`,data, {
      headers: TokenService.getHeader(),
    });
    return response
  },
  async createCrossFeeTransferProductApi(data) {
    const response = await Repository.post(`${Repository.defaults.baseURL}/order-version-2/create-cross-fee-transfer-product-order`,data, {
      headers: TokenService.getHeader(),
    });
    return response
  },
  async updateDepositLean(orderId) {
    const response = await Repository.post(`${Repository.defaults.baseURL}/order-version-2/update-to-deposit-lean/${orderId}`, {}, {
      headers: TokenService.getHeader(),
    })
    return response;
  },
  async getProductToPaymentReceiptApi(params= {}) {
    const response = await Repository.get(`${Repository.defaults.baseURL}/payment-receipt/get-calc-product-to-payment-receipt`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response;
  },
  async createProductToPaymentReceiptApi(data= {}) {
    const response = await Repository.post(`${Repository.defaults.baseURL}/payment-receipt/create`, data,{
      headers: TokenService.getHeader(),
    })
    return response;
  },
  async getIntoMoneyPaymentReceiptApi(params= {}) {
    const response = await Repository.get(`${Repository.defaults.baseURL}/payment-receipt/calc-into-money-payment-receipt`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response;
  },
  async getPaymentMethodApi(contactId= '') {
    const response = await Repository.get(`${Repository.defaults.baseURL}/payment-receipt/${contactId}`, {
      headers: TokenService.getHeader(),
    })
    return response;
  },
  async getHistoryReceiptApi(contactId) {
    const response = await Repository.get(`${Repository.defaults.baseURL}/payment-receipt?contactId=${contactId}`, {
      headers: TokenService.getHeader(),
    })
    return response;
  },
}
